import { locales } from "configs/i18n";
import i18next from "i18next";

i18next.addResources(locales.EN, "STEP_1", {
  TITLE: "TELL US WHAT YOU THOUGHT OF OUR DIGITAL SERVICES & EXPERIENCES",
  TEXT_AREA_TITLE: "Tell us more:",
  DONE: "Done",
});
